export const TRANSLATIONS_NAMESPACE = 'form-viewer';

//# sourceMappingURL=locale.js.map